import { createContext } from 'react';

const AppContext = createContext({
  isFluid: false,
  isRTL: false,
  isDark: false,
  navbarPosition: 'vertical',
  showBurgerMenu: false,
  isSidebarCollapsed: false,
  currency: '$',
  user: null,
  token: null,
  setIsFluid: () => { },
  setIsRTL: () => { },
  setIsDark: () => { },
  setNavbarPosition: () => { },
  setShowBurgerMenu: () => { },
  setIsSidebarCollapsed: () => { },
  setCurrency: () => { },
  setUser: () => { },
  setToken: () => { },
  sessionReady: false,
  setSessionReady: () => { },
  clearAuth: () => { },
  taskNotify: [],
  setTaskNotify: () => { }
});

export const EmailContext = createContext({ emails: [] });

export const ProductContext = createContext({ products: [] });

export const FeedContext = createContext({ feeds: [] });

export default AppContext;
